import React from 'react'
import Helmet from 'react-helmet'
import 'font-awesome/scss/font-awesome.scss'
import Navigation from '../components/Navigation'
import config from '../../data/SiteConfig'
import '../styles/index.scss'
import Hero from '../components/Hero'
import Footer from '../components/Footer'

export default class MainLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = { heroStyle: {} }
  }

  componentDidMount() {
    if (this.props.heroImage) {
      this.setState(() => ({ heroStyle: { background: 'transparent' } }))
    }
  }

  render() {
    const { children } = this.props
    return (
      <div className="page">
        <Navigation
          config={config}
          LocalTitle={this.props.title}
          heroType={this.props.heroType ? this.props.heroType : ''}
        >
          <div
            style={this.state.heroStyle}
            id="main-content"
            className={`layout-container ${this.props.heroType} ${
              this.props.scroll ? 'with-scroll' : 'no-scroll'
            }`}
          >
            {this.props.heroImage}
            <Helmet>
              <meta name="description" content={config.siteDescription} />
            </Helmet>
            <Hero
              heroType={this.props.heroType ? this.props.heroType : ''}
              heroTreatment={
                this.props.heroTreatment ? this.props.heroTreatment : ''
              }
              alignLeft={this.props.alignLeft}
              postType={this.props.postType}
            >
              {this.props.hero}
            </Hero>
            {this.props.scroll}
          </div>
        </Navigation>
        <div
          className={`page-content ${this.props.postType ?? ''}`}
          id="page-content"
        >
          {children}
        </div>
        <Footer />
      </div>
    )
  }
}
